<template>
  <div>
    <div id="video-container" v-if="ezvizStatus"></div>
    <div id="video-container_01" v-else></div>
  </div>
</template>
<script>
import EZUIKit from 'ezuikit-js';

import { findSuperToken } from '@/api/device';

export default {
  // props: ['camera'],
  data() {
    return {
      camera_id: '',
      camera_list: [],
      url: '',
      camera: {
        player: null
      },
      ezvizData: '',
      ezvizStatus: false
    };
  },
  created() {
    // this.url = 'ezopen://open.ys7.com/' + this.camera.deviceNo + '/1.hd.live';
    // this.url = 'ezopen://open.ys7.com/BC2478570/2.hd.live';
    // console.log(this.url);
    // findSuperToken({
    //   // deviceType: this.camera.deviceType
    //   deviceType: 1
    // }).then(res => {
    //   const data = res.data;
    //   if (data.code < 1) {
    //     this.init(data.data);
    //   }
    // });
  },
  mounted() {},
  methods: {
    // num (1, 代表普通 2, 代表360全景) BC2478570
    deviceInit(deviceNo, num) {
      this.ezvizStatus = true;
      this.url = '';
      if (num === 2) this.url = `ezopen://open.ys7.com/${deviceNo}/2.hd.live`;
      else this.url = `ezopen://open.ys7.com/${deviceNo}/1.hd.live`;
      findSuperToken({
        deviceType: 1
      }).then(res => {
        const data = res.data;
        if (data.code < 1) {
          // this.ezvizData = data.data;
          this.init(data.data, num);
        }
      });
    },
    cameraInit() {
      this.camera.player = null;
      this.ezvizStatus = false;
    },
    init(accessToken, num) {
      const that = this;
      this.ezvizStatus = num == 2 ? true : false;
      this.camera.player = null;

      setTimeout(() => {
        that.camera.player = new EZUIKit.EZUIKitPlayer({
          id: num == 2 ? 'video-container' : 'video-container_01', // 视频容器ID
          accessToken: accessToken, // token
          url: this.url, // ezopen://open.ys7.com/设备编号/1.live （设备编号（萤石摄像头后面的序列号） L05968298
          // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;
          // template: 'pcLive-pc',
          // plugin: ['talk'], // 加载插件，talk-对讲
          width: 960,
          height: 550,
          template: num == 2 ? 'pcLive' : 'standard',
          handleSuccess: function () {
            that.$emit('handleSuccess');
          },
          handleError: function () {
            that.$emit('handleError');
          }
          // useHardDev: true
        });
        that.camera.player.loadingVisible = false;
      }, 500);

      // window.player = player;
      // this.$emit('autoPlay', this.camera);
    }
    // but() {
    //   this.camera.player.stop();
    //   this.camera.player = null;
    // }
  }
  // destroyed() {
  //   this.but();
  // }
};
</script>
<style lang="scss">
#video-container-talk-icon {
  display: none;
}
#video-container-zoom-icon {
  display: none;
}
#video-container-recordvideo-icon {
  display: none;
}
#video-container-capturePicture-icon {
  display: none;
}
#video-container-hdSelect-icon {
  display: none;
}
#video-container-expend {
  display: none;
}
#video-container-sound-content {
  display: none !important;
}
#video-container-headControl {
  display: none !important;
}
.header-controls {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ezviz.vue